// src/utils/analytics.js
// Lazy-loaded analytics - loads after initial render for better performance

let analyticsLoaded = false;

export const loadAnalytics = () => {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  // Use requestIdleCallback or setTimeout as fallback
  const scheduleLoad = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

  scheduleLoad(() => {
    // Google Analytics
    loadGoogleAnalytics();

    // Mixpanel
    loadMixpanel();

    // Twitter Pixel
    loadTwitterPixel();
  });
};

const loadGoogleAnalytics = () => {
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-R876XJCP88';
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'G-R876XJCP88');

  // Send UTM capture event if available
  if (window.skimzUTM && Object.keys(window.skimzUTM).length) {
    gtag('event', 'utm_capture', window.skimzUTM);
  }
};

const loadMixpanel = () => {
  // eslint-disable-next-line no-unused-expressions
  (function(c, a) {
    window.mixpanel = a;
    var b, d, h, e;
    b = c.createElement('script');
    b.type = 'text/javascript';
    b.async = b.defer = true;
    b.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
    d = c.getElementsByTagName('script')[0];
    d.parentNode.insertBefore(b, d);
    a._i = [];
    a.init = function(initB, initC, f) {
      function initD(innerB, innerC) {
        var innerA = innerC.split('.');
        if (innerA.length === 2) {
          innerB = innerB[innerA[0]];
          innerC = innerA[1];
        }
        innerB[innerC] = function() {
          innerB.push([innerC].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      var g = a;
      if (typeof f !== 'undefined') {
        g = a[f] = [];
      } else {
        f = 'mixpanel';
      }
      g.people = g.people || [];
      h = ['disable', 'track', 'track_pageview', 'track_links', 'track_forms', 'register', 'register_once', 'unregister', 'identify', 'reset', 'people.set', 'people.increment'];
      for (e = 0; e < h.length; e++) initD(g, h[e]);
      a._i.push([initB, initC, f]);
    };
    a.__SV = 1.3;
  })(document, window.mixpanel || []);

  window.mixpanel.init('498c89f4c77bfe28d0d2153890b8b771', {
    debug: false,
    track_pageview: false,
    batch_requests: true,
    batch_flush_interval_ms: 60000,
    loaded: function() {
      if (window.skimzUTM && Object.keys(window.skimzUTM).length) {
        window.mixpanel.register(window.skimzUTM);
      }

      try {
        const ua = navigator.userAgent;
        const browser =
          ua.includes('Chrome') ? 'Chrome' :
          ua.includes('Safari') && !ua.includes('Chrome') ? 'Safari' :
          ua.includes('Firefox') ? 'Firefox' :
          ua.includes('Edge') ? 'Edge' :
          ua.includes('Trident') ? 'IE' : 'Unknown';

        window.mixpanel.track('Page Visit', {
          timestamp: new Date().toISOString(),
          browser,
          device_type: /Android|iPhone|iPad|iPod/i.test(ua) ? 'Mobile' : 'Desktop',
          screen_w: window.innerWidth,
          screen_h: window.innerHeight,
          referrer: document.referrer || 'Direct',
          url_path: window.location.pathname
        });
      } catch (_) { /* ignore tracking errors */ }
    }
  });
};

const loadTwitterPixel = () => {
  (function(e, t, n) {
    if (!e.twq) {
      var s = e.twq = function() {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
      };
      s.version = '1.1';
      s.queue = [];
      var u = t.createElement(n);
      u.async = true;
      u.src = 'https://static.ads-twitter.com/uwt.js';
      var a = t.getElementsByTagName(n)[0];
      a.parentNode.insertBefore(u, a);
    }
  })(window, document, 'script');
  window.twq('config', 'podaf');
};
